const convert = require('convert-units');

const ALLOWED_VOLUME_UNITS = [...convert().possibilities('volume'), 'cft', 'ccm', 'cdm'];
const ALLOWED_WEIGHT_UNITS = [...convert().possibilities('mass'), 'ton', 't'];
const ALLOWED_QUANTITY_UNITS = ['c/s', 's/o', 'cs', 'box', 'boxes', 'pkg', 'mt',
  'pkgs', 'cases', 'case', 'nos', 'pce', 'no', 'pcs', 'bags', 'each', 'ea', 'kar', 'ctn', 'st', 'ltr',
  'lt', 'liter', 'litre', 'litres', 'ltrs', 'liters', 'kg', 'kgs', 'pc', 'PC', 'CV', 'cv', 'PAC', 'pac', 'ECH', 'ech','per box'];

module.exports = {
  ALLOWED_VOLUME_UNITS,
  ALLOWED_WEIGHT_UNITS,
  ALLOWED_QUANTITY_UNITS,
};